import { Component, inject } from '@angular/core';
import { LayoutContextService } from '../../layout-context.service';
import { ContentFullComponent } from './variants/content-full/content-full.component';
import { ContentSidebarComponent } from './variants/content-sidebar/content-sidebar.component';

@Component({
  selector: 'gb-content',
  standalone: true,
  imports: [ContentFullComponent, ContentSidebarComponent],
  template: `
    @switch (ctx().slots.content) {
      @case ('full') {
        <gb-content-full />
      }
      @case ('sidebar') {
        <gb-content-sidebar [ctx]="ctx()" />
      }
    }
  `,
})
export class ContentHostComponent {
  protected readonly ctx = inject(LayoutContextService).context;
}
